import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as V4ThemeProvider } from "@mui/styles";
import { StyledEngineProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SnackbarProvider } from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";

import "dayjs/locale/en-gb";

import { RouterConfig } from "./app/router/router";
import { hermesTheme } from "./theme/hermesTheme";
import { keyframes } from "./theme/animations";

/**
 * Global styles component
 * Injects keyframes and base styles
 */
const GlobalStyles = () => (
  <style>{`
    ${keyframes.fadeIn}
    ${keyframes.slideUp}
    ${keyframes.slideDown}
    ${keyframes.scaleIn}
    ${keyframes.shimmer}

    body {
      background-color: ${hermesTheme.palette.background.default};
      font-family: ${hermesTheme.typography.fontFamily};
    }

    * {
      box-sizing: border-box;
    }

    /* Smooth scrolling */
    html {
      scroll-behavior: smooth;
    }

    /* Respect user's motion preferences */
    @media (prefers-reduced-motion: reduce) {
      *,
      *::before,
      *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
      }
    }
  `}</style>
);

export default function App() {
  return (
    <Box id="box-root">
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={hermesTheme}>
            {/* V4ThemeProvider for makeStyles compatibility */}
            <V4ThemeProvider theme={hermesTheme}>
              <CssBaseline />
              <GlobalStyles />
              <SnackbarProvider
                maxSnack={30}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              >
                <RouterConfig />
              </SnackbarProvider>
            </V4ThemeProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </LocalizationProvider>
    </Box>
  );
}
